/**
 * 获取对象的类型
 * @param  {*} obj
 * @return {String}
 *
 * @example
 * typeOf([]) === 'Array'
 * typeOf() === 'Undefined'
 * typeOf(1) === 'Number'
 */
export function typeOf(obj) {
  return Object.prototype.toString.call(obj).replace(/\[object\s|]/g, '');
}

/**
 * 是否是一个纯净的对象
 * @param  {*}  obj
 * @return {Boolean}
 * @reference https://github.com/jonschlinkert/is-plain-object
 */
export function isPlainObject(obj) {
  if (typeOf(obj) !== 'Object') {
    return false;
  }
  var ctor = obj.constructor;
  if (typeof ctor !== 'function') {
    return false;
  }
  var prot = ctor.prototype;
  if (typeOf(prot) !== 'Object') {
    return false;
  }
  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  }
  return true;
}
export var normalizeValue = function normalizeValue(value) {
  // id兼容处理为 string 类型
  if (value) {
    return isPlainObject(value) ? value : String(value);
  }
  return '';
};